import { Observable } from "rxjs";
import NetworkService from "../network/networkService";
import AUTH_CONFIG from "../config/auth.config";
import ENTRA_AUTH_CONFIG from "../config/entra.auth.config";


export const getTokenDetails = (code: any, codeVerifier: any): Observable<any> => {
  const url  = `${AUTH_CONFIG.SSO_BASE_PATH}${AUTH_CONFIG.TOKEN_URL}`;
 
  const requestPayload = {
      client_id: `${AUTH_CONFIG.SSO_CLIENT_ID}`,
      redirect_uri: `${AUTH_CONFIG.SSO_REDIRECT_URI}`,
      code_verifier: codeVerifier,
      grant_type: `${AUTH_CONFIG.GRANT_TYPE}`,
      code: code,
  }
  return new Observable((subscriber) => {
    NetworkService.post(url, requestPayload, {headers: { 'Content-Type': 'application/x-www-form-urlencoded', Authorization: '' },
    }).then(
      (response: unknown) => {
        if (response) {
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching toke details", error);
      }
    );
  });
};

export const getEntraTokenDetails = (code: any, codeVerifier: any): Observable<any> => {
  const url  = `${ENTRA_AUTH_CONFIG.ENTRA_SSO_BASE_PATH}${ENTRA_AUTH_CONFIG.TOKEN_URL}`;

  const requestPayload = {
    client_id: `${ENTRA_AUTH_CONFIG.ENTRA_SSO_CLIENT_ID}`,
    redirect_uri: `${ENTRA_AUTH_CONFIG.SSO_REDIRECT_URI}`,
    code_verifier: codeVerifier,
    grant_type: `${ENTRA_AUTH_CONFIG.GRANT_TYPE}`,
    code: code,
    scope: `${ENTRA_AUTH_CONFIG.TOKEN_SCOPE}`,
  }
  
  return new Observable((subscriber) => {
    NetworkService.post(url, requestPayload, {headers: { 'Content-Type': 'application/x-www-form-urlencoded', Authorization: '' },
    }).then(
      (response: unknown) => {
        if (response) {
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching toke details", error);
      }
    );
  });
};






